<template>
  <div id="app">
    <app-header></app-header>
    <vue-page-transition name="fade">
    	<router-view />
	  </vue-page-transition>
    <!-- globar-chat box start -->

    <chat-box v-if="currentRoute"></chat-box>
    <!-- globar-chat box end -->
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>



<script>

import { EventBus } from './main';
import header from "@/components/layouts/Header.vue";

export default {
  data() {
      return {
        currentRoute:''
      }
  },
  components: {
    'app-header':header
  },

  methods: {
    isCurrentRoute() {
      return this.$route.path=="/" ? this.currentRoute=false : this.currentRoute=true;
    }
  },

  mounted() {
    this.isCurrentRoute();

    EventBus.$on('isCurrentRoute', data => {
      this.currentRoute = data;
    });
  }
}

</script>


<style>

</style>